var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"size":"sm","variant":"outline-secondary"},on:{"click":_vm.doResearch}},[_c('b-icon-clipboard-data'),_c('span',{staticClass:"ml-2 mr-1"},[_vm._v("Research")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }